module.exports = __webpack_public_path__ + "static/media/reports_conflict_matrix_report.96fe1e39.mov";